<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'settings.billing.yearlyLicensePurchase.title' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="form" (submit)="submit()" class="form">
      <div class="form-field">
        <label class="field-label">{{ 'settings.billing.yearlyLicensePurchase.numberOfLicenses' | translate }}</label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="numberOfEmployees" type="number" [min]="isAdditionalPurchase ? 0 : 10" [errorStateMatcher]="errorStateMatcher">
          <mat-hint>{{ 'settings.billing.yearlyLicensePurchase.licenseHint' | translate }}</mat-hint>
          <mat-error *ngIf="form.hasError('required', ['numberOfEmployees'])">
            {{ 'fieldRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="form.hasError('min', ['numberOfEmployees'])">
            {{ 'settings.billing.yearlyLicensePurchase.minLicenseError' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="price-summary" *ngIf="calculatedPrice > 0">
        <div class="price-row">
          <div class="price-row-content">
            <div class="price-row-header">
              <span class="price-label">{{ 'settings.billing.yearlyLicensePurchase.totalPrice' | translate }}:</span>
              <span class="price-value">{{ calculatedPrice | number:'1.2-2' }} {{ data.currency }}</span>
            </div>
            <div class="price-info" *ngIf="!isAdditionalPurchase">
              {{ 'settings.billing.yearlyLicensePurchase.priceNote' | translate }}
            </div>
            <div class="price-info" *ngIf="isAdditionalPurchase">
              {{ 'settings.billing.yearlyLicensePurchase.priceNoteAdditional' | translate }}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">{{ 'cancel' | translate }}</button>
    <button mat-raised-button color="primary" type="submit" (click)="submit()" [disabled]="sendingRequest">
      {{ sendingRequest ? ('saving' | translate) : ('settings.billing.yearlyLicensePurchase.proceed' | translate) }}
    </button>
  </footer>
</div>
